<template>
	<modal width="50" :show-modal="showModal" @close-modal="$emit('close-modal')" :showTitle="false"
		:showCancleBtn="true" :showFooter="false">
		<div class="w-full">
			<div class="flex items-center gap-4">
				<img width="40" src="../../../../../assets/images/icons/dispatch-modal-truck.png">
				<div>
					<h4>Fleet Dispatch Overview</h4>
					<p class=" text-gray-400">Review fleet details before dispatching</p>
				</div>
			</div>
			<hr class=" my-4" />
			<div class="dist_item_contain">
				<div class="disp_item_list">
					<span class=" text-gray-400">
						Fleet
					</span>
					<span>{{ longHaulDispatchables?.fleet || 'N/A' }}</span>
				</div>
				<div class="disp_item_list">
					<span class=" text-gray-400">
						Driver
					</span>
					<span>{{ longHaulDispatchables?.driver || "N/A" }}</span>
				</div>
				<div class="disp_item_list">
					<span class=" text-gray-400">
						Capacity
					</span>
					<span>
						{{ longHaulDispatchables?.capacity || "N/A" }}
					</span>
				</div>
				<div class="disp_item_list">
					<span class=" text-gray-400">
						Total Consolidation
					</span>
					<span>
						{{ longHaulDispatchables?.items.length || "0" }}
					</span>
				</div>
				<div class="disp_item_list">
					<span class=" text-gray-400">
						Total Shipment
					</span>
					<span>
						{{ longHaulDispatchables?.totalShipment || "N/A" }}
					</span>
				</div>
			</div>
			<div class="flex justify-between py-2"><b>Consolidation Assigned</b> {{
				longHaulDispatchables?.totalConsolidation || "N/A" }} item(s)</div>

			<table class="w-full table-auto">
				<thead>
					<tr>
						<th class="text-[#383F51] text-[12px] font-normal text-left">Consolidation ID</th>
						<th class="text-[#383F51] text-[12px] font-normal text-left">Destination</th>
						<th class="text-[#383F51] text-[12px] font-normal text-left">Current Status</th>
						<th class="text-[#383F51] text-[12px] font-normal text-left">Action</th>
					</tr>
				</thead>
				<tbody>
					<tr v-for="(dispatch, index) in longHaulDispatchables.items" :key="index">
						<td>{{ dispatch?.consolidationId || "N/A" }}</td>
						<td>{{ dispatch?.destination || "N/A" }}</td>
						<td>
							<button :title="dispatch.currentStatus.replace(/_/g, ' ')" :class="['order_status']"
								:style="{ ...statusColors(dispatch.currentStatus) }">
								{{ dispatch.currentStatus.replace(/_/g, ' ').toLowerCase() }}</button>
						</td>
						<td> <span v-if="dispatch?.currentStatus === 'ready_for_dispatch'" class=" cursor-pointer"> ...
							</span> <span v-else @click="updateStatus(dispatch)" class=" cursor-pointer"> Update Status
							</span></td>
					</tr>
				</tbody>
			</table>

			<div class="button_wrapper">
				<button @click="$emit('close-modal')">
					Cancel
				</button>

				<base-button @click="createDispatch" text="Continue Dispatch" :disabled="!canContinueDispatch" :class="[
					!canContinueDispatch
						? 'opacity-50 cursor-not-allowed'
						: 'cursor-pointer'
				]" />
			</div>
		</div>
	</modal>


</template>

<script>
export default {
	components: {},
	props: {

		showModal: {
			type: Boolean,
			required: true,
			default: false,
		},
		selcetdDispatchDetail: {
			type: Array,
			required: false,
			default: null
		},
		selecetedDispatch: {
			type: Array,
			required: false,
			default: null
		},
		longHaulDispatchables: {
			type: Object
			// required: false,
			// default: null
		}
	},
	data() {
		return {

		}
	},

	computed: {
		canContinueDispatch() {
			const items = this.longHaulDispatchables?.items || [];

			if (!items.length) return false;

			return items.every(
				dispatch =>
					dispatch?.currentStatus === 'ready_for_dispatch'
			);
		}
	},


	methods: {
		statusColors(status) {
			const opac = "25";
			switch (status) {
				case "pending_loading":
					return { color: "#FFA600", backgroundColor: "#FFA60030" };
				case "loading":
					return { color: "#09B78A", backgroundColor: "#09B78A" + opac };
				case "loading_complete":
					return { color: "#09B78A", backgroundColor: "#09B78A" + opac };
				case "dispatched_for_delivery":
					return { color: "#09B78A", backgroundColor: "#09B78A" + opac };
				case "on-hold":
					return { color: "#FFA600", backgroundColor: "#FFA60030" };
				case "ready_for_dispatch":
					return { color: "#000000", backgroundColor: "#000000" + opac };
			}
		},
		createDispatch() {
			if (!this.canContinueDispatch) return;

			this.$emit("create-dispatch");
			this.closeModal()
		},
		updateStatus(val) {
			this.$emit("open-update-status-modal", val);
			console.log(val);

		},
		dispatch() {
			this.closeModal()
			this.$emit("open-dispatch-modal");

		},
		closeModal() {
			this.$emit("close-modal");
		},

	}
};
</script>

<style scoped>
.delete-modal {
	text-align: center;
}

.disp_item_list {
	@apply flex items-center justify-between border-b-[1px] border-gray-200 py-3 text-sm
}

.disp_item_list:nth-last-of-type(1) {
	@apply border-none
}

.dist_item_contain {
	@apply border-[1px] border-gray-200 p-3 rounded-xl
}

.button_wrapper {
	@apply mt-7 flex justify-end gap-5
}

.table-head {
	background: #EBF2FA;
}

/* .table-body {
	border: 1px solid red;
} */
.table-body>span {
	/* border: 1px solid blue; */
	text-align: end;

}

.order_status {
	@apply text-xs w-[140px] whitespace-nowrap capitalize text-ellipsis overflow-hidden rounded-2xl py-1.5 px-3
}
</style>